import React, { useState } from "react";
import PropTypes from "prop-types";

export default function GroupsIndex(props) {
  const [groups, setGroups] = useState(props.groups);
  const [saving, setSaving] = useState(false);
  const [memberships, setMemberships] = useState(props.counts ? props.counts : [])

  const getCount = (id) => {
    let groupCount = memberships.find(count => count.id == id)
    return groupCount.members_count ? groupCount.members_count : 0
  }

  return (
    <React.Fragment>
      <div className="card">
        <div>
          <div className="list-group list-group-flush">
            {groups.map((group, index) => (
              <div key={group.id} className="list-group-item">
                <div className="list-group-item-body">
                  <div className="list-group-item-body-main">
                    <span>{group.name}</span>
                  </div>
                  {getCount(group.id)} Members
                </div>
                <div className="list-group-item-actions d-none-mobile">
                  <a
                    href={`/groups/${group.id}`}
                    className="btn btn-sm btn-outline-primary"
                  >
                    View Group
                  </a>
                  <a
                    href={`/groups/${group.id}/edit`}
                    className="btn btn-sm btn-primary ml-2"
                  >
                    <i className="fa fa-pencil"></i> Edit Group
                  </a>
                </div>
                <div className="dropdown">
                  <button
                    className="btn btn-primary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                  >
                    Actions
                  </button>
                  <ul className="dropdown-menu">
                    <li className="dropdown-item">
                      <a href={`/groups/${group.id}`}>View Group</a>
                    </li>
                    <li className="dropdown-item">
                      <a href={`/groups/${group.id}/edit`}>Edit Group</a>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        {groups.length == 0 && (
          <div className="card-body">
            Let's get started and add your first group :)
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

GroupsIndex.propTypes = {
  groups: PropTypes.array,
};
